/* eslint-disable no-debugger */
import { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import NavLinks from '../NavLinks';

import useClubRegistrationNavData from '../../../state/clubRegistration/leftNavigation/UseClubRegistrationNavData';
import useClubRegistrationNewData from '../../../state/clubRegistrationNew/UseClubRegistrationNewData';
import useUsasClubFileData from '../../../state/clubFile/UseUsasClubFileData';

import Constants from '@usas/ui-web/utils/Constants';
import ClubRegistrationConstants from '../utils/ClubRegistrationConstants';


const BUDGET_OR_BUSINESS_PLAN = 'First Year Budget or Business Plan';
const BUDGET_OR_BUSINESS_PLAN_TYPE = 'budget';

const STRATEGIC_PLAN = 'Strategic Plan';
const STRATEGIC_PLAN_TYPE = 'strategicPlan';


const HEAD_COACH_RESUME = 'Head Coach Resume';
const HEAD_COACH_RESUME_TYPE = 'headCoachResume';

const OWNER_BOARD_EXPERIENCE_RESUME = 'Owner Board Experience Resume';
const OWNER_BOARD_EXPERIENCE_RESUME_TYPE = 'ownerBoardExperienceResume';

const HANDBOOK = 'Handbook File';
const HANDBOOK_TYPE = 'handbook';

const FIRST_YEAR_BUDGET = 'First Year Budget';

const SAVING_ERROR_MSG = 'The last action is still saving. Please try again.';
const FILE_TYPE_ERROR_MSG = 'File type not permitted. Please provide a (*.pdf), (*.doc), or (*.docx) file.';
const REQUIRED_ERROR_MSG = 'An uploaded mission statement and budget are required';
const FILE_MODAL_TITLE = 'Remove Uploaded File?';

const useClubRegistrationMissionStatementBudget = () => {
  const navigate = useNavigate();
  const [state, setState] = useState({ submitButton: '', tryRedirect: false, error: '' });
  const [submitPrequisitesState, setSubmitPrequisitesState] = useState({ areSubmitPrerequisitesDone: false });
  const [fileState, setFileState] = useState({
    budgetFile: false, budgetFileUrl: '', budgetFileName: '',
    strategicPlanFile: false, strategicPlanFileUrl: '', strategicPlanFileName: '',
    headCoachResumeFile: false, headCoachResumeFileUrl: '', headCoachResumeFileName: '',
    ownerBoardExperienceResumeFile: false, ownerBoardExperienceResumeFileUrl: '', ownerBoardExperienceResumeFileName: '',
    firstYearBudgetFile: false, firstYearBudgetFileUrl: '', firstYearBudgetFileName: '',
    handbookFile: false, handbookFileUrl: '', handbookFileName: ''
  });
  const [modalState, setModalState] = useState(getInitialModalState());
  const [removeFileModalState, setRemoveFileModalState] = useState(getInitialRemoveFileModalState());
  const { clubRegistrationNavState, setClubRegistrationNavState } = useClubRegistrationNavData();
  const { clubRegistrationState, putUsasClub } = useClubRegistrationNewData();
  const { usasClubFileUploadState, postUsasClubFile, getFileNameFromSavedUploadUrl, getFileNameFromUrl, getUsasClubFileTemplate,
    getUsasClubFile } = useUsasClubFileData();

  const editClubObj = (name, type) => {
    const clubCopy = { ...clubRegistrationState.objData };

    if (!clubCopy.usasClubAcknowledgement || clubCopy.usasClubAcknowledgement.length === 0) {
      // Initialize the acknowledgment array if it doesn't exist or is empty
      clubCopy.usasClubAcknowledgement = [{
        usasClubId: clubCopy.usasClubId,
        budgetUrl: type === BUDGET_OR_BUSINESS_PLAN ? name : null,
        strategicPlanUrl: type === STRATEGIC_PLAN ? name : null,
        headCoachResumeUrl: type === HEAD_COACH_RESUME ? name : null,
        ownerBoardExperienceResumeUrl: type === OWNER_BOARD_EXPERIENCE_RESUME ? name : null,
        handbookUrl: type === HANDBOOK ? name : null
      }];
    } else if (clubCopy.usasClubAcknowledgement.length === 1) {
      // Update the existing acknowledgment object
      const acknowledgment = { ...clubCopy.usasClubAcknowledgement[0] };

      switch (type) {
        
        case BUDGET_OR_BUSINESS_PLAN:
          acknowledgment.budgetUrl = name;
          break;
        case STRATEGIC_PLAN:
          acknowledgment.strategicPlanUrl = name;
          break;
        
        case HEAD_COACH_RESUME:
          acknowledgment.headCoachResumeUrl = name;
          break;
        case OWNER_BOARD_EXPERIENCE_RESUME:
          acknowledgment.ownerBoardExperienceResumeUrl = name;
          break;
        case HANDBOOK:
          acknowledgment.handbookUrl = name;
          break;
        default:
          break;
      }

      clubCopy.usasClubAcknowledgement = [acknowledgment];
    }

    return clubCopy;
  };

  const onRemoveDocumentClicked = (e, type) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setRemoveFileModalState({ ...getInitialRemoveFileModalState() });
    if (clubRegistrationState.isSaving === true) {
      setState({ ...state, submitButton: '', tryRedirect: false, error: SAVING_ERROR_MSG });
    }
    else {
      const navIndex = clubRegistrationNavState.findIndex(x => x.name === ClubRegistrationConstants.MISSION_STATEMENT_BUDGET)
      clubRegistrationNavState[navIndex] =
      {
        ...clubRegistrationNavState[navIndex],
        isCurrent: true,
        isComplete: false,
        isVisited: true,
        arePrerequisitesDone: true
      }
      const submitNavIndex = clubRegistrationNavState.findIndex(x => x.name === ClubRegistrationConstants.SUBMIT)
      clubRegistrationNavState[submitNavIndex] =
      {
        ...clubRegistrationNavState[submitNavIndex],
        isCurrent: false,
        isComplete: false,
        isVisited: false,
        arePrerequisitesDone: false
      }
      setSubmitPrequisitesState({ ...submitPrequisitesState, areSubmitPrerequisitesDone: false });
      setClubRegistrationNavState(clubRegistrationNavState);
      setState({ ...state, submitButton: '', tryRedirect: false, error: '' });

      
      if (type === BUDGET_OR_BUSINESS_PLAN) {
        setFileState({ ...fileState, budgetFileUrl: '', budgetFileName: '' });
      } else if (type === STRATEGIC_PLAN) {
        setFileState({ ...fileState, strategicPlanFileUrl: '', strategicPlanFileName: '' });
      }
      
      else if (type === HEAD_COACH_RESUME) {
        setFileState({ ...fileState, headCoachResumeFileUrl: '', headCoachResumeFileName: '' });
      } else if (type === OWNER_BOARD_EXPERIENCE_RESUME) {
        setFileState({ ...fileState, ownerBoardExperienceResumeFileUrl: '', ownerBoardExperienceResumeFileName: '' });
      } else if (type === HANDBOOK) {
        setFileState({ ...fileState, handbookFileUrl: '', handbookFileName: '' });
      }

      const name = null;
      putUsasClub(clubRegistrationState.objData.usasClubId, editClubObj(name, type));
    }
  }

  const onUploadDocumentClicked = (e, type) => {
    if (clubRegistrationState.isSaving === true) {
      setState({ ...state, submitButton: '', tryRedirect: false, error: SAVING_ERROR_MSG });
    }
    else {
      setState({ ...state, submitButton: '', tryRedirect: false, error: '' });
      if (e.target.files[0]) {
        const file = e.target.files[0];
        const fileName = clubRegistrationState.objData.usasClubId + ' ' + e.target.files[0].name;
        const fileType = e.target.files[0].type;

        let fileTypeValid = false;

        if (type === BUDGET_OR_BUSINESS_PLAN &&
          (fileType === Constants.FILE_TYPE_PDF ||
            fileType === Constants.FILE_TYPE_DOC ||
            fileType === Constants.FILE_TYPE_DOCX ||
            fileType === Constants.FILE_TYPE_XLSX)) {
          fileTypeValid = true;
        } else if (type !== BUDGET_OR_BUSINESS_PLAN && 
          (fileType === Constants.FILE_TYPE_PDF ||
          fileType === Constants.FILE_TYPE_DOC ||
          fileType === Constants.FILE_TYPE_DOCX)) {
          fileTypeValid = true;
        }

        if (fileTypeValid === true) {
          setFileState({
            ...fileState,
            budgetFile: type === BUDGET_OR_BUSINESS_PLAN ? true : false,
            strategicPlanFile: type === STRATEGIC_PLAN ? true : false,
            headCoachResumeFile: type === HEAD_COACH_RESUME ? true : false,
            ownerBoardExperienceResumeFile: type === OWNER_BOARD_EXPERIENCE_RESUME ? true : false,
            firstYearBudgetFile: type === FIRST_YEAR_BUDGET ? true : false,
            handbookFile: type === HANDBOOK ? true : false
          });
          setState({ ...state, submitButton: '', tryRedirect: false, error: '' });
          postUsasClubFile(file, fileName);
        }
        else {
          setState({ ...state, submitButton: '', tryRedirect: false, error: FILE_TYPE_ERROR_MSG });
        }
      }
    }
  }

  const onContinueClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (clubRegistrationState.objData?.usasClubAcknowledgement?.length > 0) {
      if (clubRegistrationState.objData.usasClubAcknowledgement.length === 1) {

        if (
          clubRegistrationState.objData?.usasClubAcknowledgement[0].budgetUrl !== null &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].strategicPlanUrl !== null &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].headCoachResumeUrl !== null &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].ownerBoardExperienceResumeUrl !== null &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].handbookUrl !== null &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].budgetUrl.includes("Bad Request") === false &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].strategicPlanUrl.includes("Bad Request") === false &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].headCoachResumeUrl.includes("Bad Request") === false &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].ownerBoardExperienceResumeUrl.includes("Bad Request") === false &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].handbookUrl.includes("Bad Request") === false
        ) {
          setState({ ...state, tryRedirect: true, submitButton: ClubRegistrationConstants.CONTINUE, error: '' });
        }
        else {
          setState({ ...state, submitButton: ClubRegistrationConstants.CONTINUE, error: REQUIRED_ERROR_MSG });
        }
      }
    }
    else {
      setState({ ...state, submitButton: ClubRegistrationConstants.CONTINUE, error: REQUIRED_ERROR_MSG });
    }
  }

  const onSaveAndExitClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (clubRegistrationState.objData?.usasClubAcknowledgement?.length > 0) {
      if (clubRegistrationState.objData.usasClubAcknowledgement.length === 1) {
        if (
          clubRegistrationState.objData?.usasClubAcknowledgement[0].budgetUrl !== null &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].strategicPlanUrl !== null &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].headCoachResumeUrl !== null &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].ownerBoardExperienceResumeUrl !== null &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].handbookUrl !== null &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].budgetFileName.includes("Bad Request") === false &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].strategicPlanFileName.includes("Bad Request") === false &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].headCoachResumeFileName.includes("Bad Request") === false &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].ownerBoardExperienceResumeFileName.includes("Bad Request") === false &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].handbookFileName.includes("Bad Request") === false
        ) {
          setState({ ...state, submitButton: ClubRegistrationConstants.EXIT, error: '' });
        }
        else {
          setState({ ...state, submitButton: ClubRegistrationConstants.EXIT, error: REQUIRED_ERROR_MSG });
        }
      }
    }
    else {
      setState({ ...state, submitButton: ClubRegistrationConstants.EXIT, error: REQUIRED_ERROR_MSG });
    }
  }

  const onBackClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (clubRegistrationState.objData?.usasClubAcknowledgement?.length > 0) {
      if (clubRegistrationState.objData.usasClubAcknowledgement.length === 1) {
        if (
          clubRegistrationState.objData?.usasClubAcknowledgement[0].budgetUrl !== null &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].strategicPlanUrl !== null &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].headCoachResumeUrl !== null &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].ownerBoardExperienceResumeUrl !== null &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].handbookUrl !== null &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].budgetUrl.includes("Bad Request") === false &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].strategicPlanUrl.includes("Bad Request") === false &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].headCoachResumeUrl.includes("Bad Request") === false &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].ownerBoardExperienceResumeUrl.includes("Bad Request") === false &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].handbookUrl.includes("Bad Request") === false
        ) {
          setState({ ...state, tryRedirect: true, submitButton: ClubRegistrationConstants.BACK, error: '' });
        }
        else {
          setState({ ...state, submitButton: ClubRegistrationConstants.BACK, error: REQUIRED_ERROR_MSG });
        }
      }
    }
    else {
      setState({ ...state, submitButton: ClubRegistrationConstants.BACK, error: REQUIRED_ERROR_MSG });
    }
  }

  const onOpenModal = () => {
    if (state.error !== '') {
      setModalState({ ...modalState, displayPopUp: true });
    }
    else {
      setModalState({ ...modalState, modalTitle: ClubRegistrationConstants.EXIT_CONFIRMATION, displayPopUp: true });
    }
  }

  const onModalContinue = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    setState({ ...state, tryRedirect: true });
    setModalState({ ...getInitialModalState() });
  }

  const onModalCanceled = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    setModalState({ ...getInitialModalState() });
  }

  const onOpenRemoveFileModalClicked = (e, fileType) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    let fileNameVal = '';
    let fileTypeVal = '';

    
    if (fileType === BUDGET_OR_BUSINESS_PLAN_TYPE) {
      fileNameVal = fileState.budgetFileName;
      fileTypeVal = BUDGET_OR_BUSINESS_PLAN;
    } else if (fileType === STRATEGIC_PLAN_TYPE) {
      fileNameVal = fileState.strategicPlanFileName;
      fileTypeVal = STRATEGIC_PLAN;
    }
    
    else if (fileType === HEAD_COACH_RESUME_TYPE) {
      fileNameVal = fileState.headCoachResumeFileName;
      fileTypeVal = HEAD_COACH_RESUME;
    } else if (fileType === OWNER_BOARD_EXPERIENCE_RESUME_TYPE) {
      fileNameVal = fileState.ownerBoardExperienceResumeFileName;
      fileTypeVal = OWNER_BOARD_EXPERIENCE_RESUME;
    } else if (fileType === HANDBOOK_TYPE) {
      fileNameVal = fileState.handbookFileName;
      fileTypeVal = HANDBOOK;
    }

    setRemoveFileModalState({
      ...removeFileModalState,
      fileType: fileTypeVal,
      fileName: fileNameVal,
      displayPopUp: true
    });
  }

  const onRemoveFileModalCanceled = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    setRemoveFileModalState({ ...getInitialRemoveFileModalState() });
  }

  const updateNavState = () => {
    for (let i = 0; i < clubRegistrationNavState.length; i++) {
      clubRegistrationNavState[i].isCurrent = false
    }
    const navIndex = clubRegistrationNavState.findIndex(x => x.name === ClubRegistrationConstants.MISSION_STATEMENT_BUDGET)

    if (clubRegistrationState.objData?.usasClubAcknowledgement?.length > 0) {
      if (clubRegistrationState.objData.usasClubAcknowledgement.length === 1) {
        if (
          clubRegistrationState.objData.usasClubAcknowledgement[0].budgetUrl !== null &&
          clubRegistrationState.objData.usasClubAcknowledgement[0].strategicPlanUrl !== null &&
          clubRegistrationState.objData.usasClubAcknowledgement[0].headCoachResumeUrl !== null &&
          clubRegistrationState.objData.usasClubAcknowledgement[0].ownerBoardExperienceResumeUrl !== null &&
          clubRegistrationState.objData.usasClubAcknowledgement[0].handbookUrl !== null &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].budgetUrl.includes("Bad Request") === false &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].strategicPlanUrl.includes("Bad Request") === false &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].headCoachResumeUrl.includes("Bad Request") === false &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].ownerBoardExperienceResumeUrl.includes("Bad Request") === false &&
          clubRegistrationState.objData?.usasClubAcknowledgement[0].handbookUrl.includes("Bad Request") === false
        ) {
          clubRegistrationNavState[navIndex] =
          {
            ...clubRegistrationNavState[navIndex],
            isCurrent: true,
            isComplete: true,
            isVisited: true,
            arePrerequisitesDone: true
          }
        }
        else {
          clubRegistrationNavState[navIndex] =
          {
            ...clubRegistrationNavState[navIndex],
            isCurrent: true,
            isComplete: false,
            isVisited: true,
            arePrerequisitesDone: true
          }
        }
      }
    }
    else {
      clubRegistrationNavState[navIndex] =
      {
        ...clubRegistrationNavState[navIndex],
        isCurrent: true,
        isComplete: false,
        isVisited: true,
        arePrerequisitesDone: true
      }
    }
    //Submit
    let areSubmitPrerequisitesDone = true;
    let isSubmitComplete = false;
    for (let i = 0; i < clubRegistrationNavState.length; i++) {
      if (clubRegistrationNavState[i].name !== ClubRegistrationConstants.SUBMIT
        && clubRegistrationNavState[i].isComplete === false) {
        areSubmitPrerequisitesDone = false;
      }
      if (clubRegistrationNavState[i].name === ClubRegistrationConstants.SUBMIT) {
        if (clubRegistrationState.objData.status === ClubRegistrationConstants.PENDING_STATUS ||
          clubRegistrationState.objData.status === ClubRegistrationConstants.APPROVED_STATUS) {
          isSubmitComplete = true
        }
      }
    }
    const submitNavIndex = clubRegistrationNavState.findIndex(x => x.name === ClubRegistrationConstants.SUBMIT)
    clubRegistrationNavState[submitNavIndex] =
    {
      ...clubRegistrationNavState[submitNavIndex],
      isCurrent: false,
      isComplete: isSubmitComplete,
      isVisited: areSubmitPrerequisitesDone === false ? false : clubRegistrationNavState[submitNavIndex].isVisited,
      arePrerequisitesDone: areSubmitPrerequisitesDone
    }
    setSubmitPrequisitesState({ ...state, areSubmitPrerequisitesDone: areSubmitPrerequisitesDone });
    setClubRegistrationNavState(clubRegistrationNavState);
  }

  const onDownloadTemplateClicked = (e, type) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    showUploadedFileTemplate(type)
  }

  const onDownloadUploadedFile = (e, fileUrl) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    showUploadedFile(fileUrl);
  }

  useEffect(() => {
    if (clubRegistrationState.isObjLoaded === false) {
      navigate(NavLinks.CLUB_REGISTRATION_ENTRY_NEW);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const navIndex = clubRegistrationNavState.findIndex(x => x.name === ClubRegistrationConstants.MISSION_STATEMENT_BUDGET)
    if (clubRegistrationNavState[navIndex].isCurrent === false) {
      updateNavState();
      if (clubRegistrationState.objData?.usasClubAcknowledgement?.length === 1) {
        setFileState({
          ...fileState,
          budgetFileUrl: clubRegistrationState.objData.usasClubAcknowledgement[0].budgetUrl !== null ?
            clubRegistrationState.objData.usasClubAcknowledgement[0].budgetUrl : '',
          budgetFileName: clubRegistrationState.objData.usasClubAcknowledgement[0].budgetUrl !== null ?
            getFileNameFromUrl(clubRegistrationState.objData.usasClubAcknowledgement[0].budgetUrl) : '',

          strategicPlanFileUrl: clubRegistrationState.objData.usasClubAcknowledgement[0].strategicPlanUrl !== null ?
            clubRegistrationState.objData.usasClubAcknowledgement[0].strategicPlanUrl : '',
          strategicPlanFileName: clubRegistrationState.objData.usasClubAcknowledgement[0].strategicPlanUrl !== null ?
            getFileNameFromUrl(clubRegistrationState.objData.usasClubAcknowledgement[0].strategicPlanUrl) : '',


          headCoachResumeFileUrl: clubRegistrationState.objData.usasClubAcknowledgement[0].headCoachResumeUrl !== null ?
            clubRegistrationState.objData.usasClubAcknowledgement[0].headCoachResumeUrl : '',
          headCoachResumeFileName: clubRegistrationState.objData.usasClubAcknowledgement[0].headCoachResumeUrl !== null ?
            getFileNameFromUrl(clubRegistrationState.objData.usasClubAcknowledgement[0].headCoachResumeUrl) : '',

          ownerBoardExperienceResumeFileUrl: clubRegistrationState.objData.usasClubAcknowledgement[0].ownerBoardExperienceResumeUrl !== null ?
            clubRegistrationState.objData.usasClubAcknowledgement[0].ownerBoardExperienceResumeUrl : '',
          ownerBoardExperienceResumeFileName: clubRegistrationState.objData.usasClubAcknowledgement[0].ownerBoardExperienceResumeUrl !== null ?
            getFileNameFromUrl(clubRegistrationState.objData.usasClubAcknowledgement[0].ownerBoardExperienceResumeUrl) : '',

          handbookFileUrl: clubRegistrationState.objData.usasClubAcknowledgement[0].handbookUrl !== null ?
            clubRegistrationState.objData.usasClubAcknowledgement[0].handbookUrl : '',
          handbookFileName: clubRegistrationState.objData.usasClubAcknowledgement[0].handbookUrl !== null ?
            getFileNameFromUrl(clubRegistrationState.objData.usasClubAcknowledgement[0].handbookUrl) : ''
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clubRegistrationNavState])

  useEffect(() => {
    const submitNavIndex = clubRegistrationNavState.findIndex(x => x.name === ClubRegistrationConstants.SUBMIT)
    if (clubRegistrationNavState[submitNavIndex].arePrerequisitesDone === false && submitPrequisitesState.areSubmitPrerequisitesDone === true) {
      updateNavState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clubRegistrationNavState, submitPrequisitesState.areSubmitPrerequisitesDone])

  useEffect(() => {
    if (Object.keys(clubRegistrationState.objData).length > 0) {
      updateNavState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clubRegistrationState.objData])

  useEffect(() => {
    if (usasClubFileUploadState.isObjLoaded === true && Object.keys(usasClubFileUploadState.objData).length > 0) {
      if (fileState.budgetFile === true) {
        setFileState({ ...fileState, budgetFile: false, budgetFileUrl: usasClubFileUploadState.objData.uploadUrl, budgetFileName: getFileNameFromSavedUploadUrl() });
        putUsasClub(clubRegistrationState.objData.usasClubId, editClubObj(usasClubFileUploadState.objData.uploadUrl, BUDGET_OR_BUSINESS_PLAN));
      }
      else if (fileState.strategicPlanFile === true) {
        setFileState({ ...fileState, strategicPlanFile: false, strategicPlanFileUrl: usasClubFileUploadState.objData.uploadUrl, strategicPlanFileName: getFileNameFromSavedUploadUrl() });
        putUsasClub(clubRegistrationState.objData.usasClubId, editClubObj(usasClubFileUploadState.objData.uploadUrl, STRATEGIC_PLAN));
      }
      
      else if (fileState.headCoachResumeFile === true) {
        setFileState({ ...fileState, headCoachResumeFile: false, headCoachResumeFileUrl: usasClubFileUploadState.objData.uploadUrl, headCoachResumeFileName: getFileNameFromSavedUploadUrl() });
        putUsasClub(clubRegistrationState.objData.usasClubId, editClubObj(usasClubFileUploadState.objData.uploadUrl, HEAD_COACH_RESUME));
      }
      else if (fileState.ownerBoardExperienceResumeFile === true) {
        setFileState({ ...fileState, ownerBoardExperienceResumeFile: false, ownerBoardExperienceResumeFileUrl: usasClubFileUploadState.objData.uploadUrl, ownerBoardExperienceResumeFileName: getFileNameFromSavedUploadUrl() });
        putUsasClub(clubRegistrationState.objData.usasClubId, editClubObj(usasClubFileUploadState.objData.uploadUrl, OWNER_BOARD_EXPERIENCE_RESUME));
      }
      else if (fileState.handbookFile === true) {
        setFileState({ ...fileState, handbookFile: false, handbookFileUrl: usasClubFileUploadState.objData.uploadUrl, handbookFileName: getFileNameFromSavedUploadUrl() });
        putUsasClub(clubRegistrationState.objData.usasClubId, editClubObj(usasClubFileUploadState.objData.uploadUrl, HANDBOOK));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usasClubFileUploadState, fileState])

  useEffect(() => {
    //Handle validation modal and navigation
    if (state.submitButton !== '' && clubRegistrationState.isObjLoaded === true) {
      if (clubRegistrationState.isSaving === true) {
        setState({ ...state, submitButton: '', tryRedirect: false, error: SAVING_ERROR_MSG });
      }
      else if (state.tryRedirect === false) {
        if (state.error !== '' || state.submitButton === ClubRegistrationConstants.EXIT) {
          onOpenModal();
        }
      }
      else if (state.tryRedirect === true) {
        //If no error (docs not uploaded) or this is a renew (length > 1) set isComplete to true
        if (state.error === '') {
          const navIndex = clubRegistrationNavState.findIndex(x => x.name === ClubRegistrationConstants.MISSION_STATEMENT_BUDGET)
          clubRegistrationNavState[navIndex] =
          {
            ...clubRegistrationNavState[navIndex],
            isCurrent: false,
            isComplete: true,
            isVisited: true,
            arePrerequisitesDone: true
          }
          //Submit
          let areSubmitPrerequisitesDone = true;
          let isSubmitComplete = false;
          for (let i = 0; i < clubRegistrationNavState.length; i++) {
            if (clubRegistrationNavState[i].name !== ClubRegistrationConstants.SUBMIT
              && clubRegistrationNavState[i].isComplete === false) {
              areSubmitPrerequisitesDone = false;
            }
            if (clubRegistrationNavState[i].name === ClubRegistrationConstants.SUBMIT) {
              if (clubRegistrationState.objData.status === ClubRegistrationConstants.PENDING_STATUS ||
                clubRegistrationState.objData.status === ClubRegistrationConstants.APPROVED_STATUS) {
                isSubmitComplete = true
              }
            }
          }
          const submitNavIndex = clubRegistrationNavState.findIndex(x => x.name === ClubRegistrationConstants.SUBMIT)
          clubRegistrationNavState[submitNavIndex] =
          {
            ...clubRegistrationNavState[submitNavIndex],
            isCurrent: false,
            isComplete: isSubmitComplete,
            isVisited: areSubmitPrerequisitesDone === false ? false : clubRegistrationNavState[submitNavIndex].isVisited,
            arePrerequisitesDone: areSubmitPrerequisitesDone
          }
          setClubRegistrationNavState(clubRegistrationNavState);
        }
        if (state.submitButton === ClubRegistrationConstants.CONTINUE) {
          navigate(NavLinks.CLUB_REGISTRATION_FACILITY);
        }
        else if (state.submitButton === ClubRegistrationConstants.EXIT) {
          navigate(NavLinks.CLUB_REGISTRATION_ENTRY_NEW);
        }
        else if (state.submitButton === ClubRegistrationConstants.BACK) {
          navigate(NavLinks.CLUB_REGISTRATION_LEGAL_ENTITY);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, clubRegistrationState.isObjLoaded])

  async function showUploadedFileTemplate(type) {
    if (type) {
      const getFileResult = await getUsasClubFileTemplate(type);

      if (getFileResult) {
        if (getFileResult.objData?.blobFile?.size > 0) {
          var file = window.URL.createObjectURL(getFileResult.objData?.blobFile);
          const link = document.createElement('a');

          link.href = file;
          link.setAttribute('target', '_blank');
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        }
      }
    }
  }

  async function showUploadedFile(fileUrl) {
    if (fileUrl) {
      const getFileResult = await getUsasClubFile(fileUrl);

      if (getFileResult) {
        if (getFileResult.objData?.blobFile?.size > 0) {
          var file = window.URL.createObjectURL(getFileResult.objData?.blobFile);
          const link = document.createElement('a');

          link.href = file;
          link.setAttribute('target', '_blank');
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        }
      }
    }
  }

  function getInitialModalState() {
    return {
      displayPopUp: false,
      modalTitle: ClubRegistrationConstants.MISSING_REQUIRED_INFORMATION
    }
  }

  function getInitialRemoveFileModalState() {
    return {
      displayPopUp: false,
      fileType: '',
      fileName: '',
      modalTitle: FILE_MODAL_TITLE
    }
  }

  return {
    clubRegistrationNavState,
    clubRegistrationState,
    state,
    fileState,
    modalState,
    removeFileModalState,
    usasClubFileUploadState,
    onUploadDocumentClicked,
    onOpenRemoveFileModalClicked,
    onRemoveFileModalCanceled,
    onModalContinue,
    onModalCanceled,
    onContinueClicked,
    onSaveAndExitClicked,
    onBackClicked,
    onDownloadTemplateClicked,
    onDownloadUploadedFile,
    onRemoveDocumentClicked
  }
}

export default useClubRegistrationMissionStatementBudget;     